import React, { useState } from "react";

import "./Footer.css";

const EmployeeCorner = () => {

  const [showLogin, setShowLogin]
  = useState(false);

  const [employeeId, setEmployeeId]
  = useState("");

  const [password, setPassword]
  = useState("");

  const [message, setMessage]
  = useState("");

  // LOGIN

  const handleLogin = async (e) => {

    e.preventDefault();

    setMessage("");

    try {

      const response = await fetch(
        "https://fidinventures.in/api/login.php",
        {
          method: "POST",

          headers: {
            "Content-Type":
            "application/json",
          },

          body: JSON.stringify({

            employeeId,

            password,

          }),
        }
      );

      const data =
      await response.json();

      console.log(data);

      // SUCCESS

      if (data.success) {

        // PASS DATA TEMPORARILY

        window.location.href =
        `/staffProfile?employeeId=${employeeId}`;

      } else {

        setMessage(
          data.message ||
          "Login Failed"
        );
      }

    } catch (error) {

      console.log(error);

      setMessage("Server Error");
    }
  };

  return (

    <>

      {/* EMPLOYEE CORNER */}

      <section className="employee-corner">

        <div className="employee-container">

          <h2>
            Employee Corner
          </h2>

          <p>
            Click below to access
            Employee Corner
          </p>

          <button
            onClick={() =>
              setShowLogin(true)
            }
          >
            Employee Access Corner
          </button>

        </div>

      </section>

      {/* LOGIN POPUP */}

      {showLogin && (

        <div className="login-overlay">

          <div className="login-popup">

            <span
              className="close-btn"
              onClick={() =>
                setShowLogin(false)
              }
            >
              ×
            </span>

            <h3>
              Employee Login
            </h3>

            <form
              onSubmit={handleLogin}
            >

              <input
                type="text"

                placeholder="Employee ID"

                value={employeeId}

                onChange={(e) =>
                  setEmployeeId(
                    e.target.value
                  )
                }

                required
              />

              <input
                type="password"

                placeholder="Password"

                value={password}

                onChange={(e) =>
                  setPassword(
                    e.target.value
                  )
                }

                required
              />

              <button type="submit">

                Login

              </button>

            </form>

            {message && (

              <p className="success-message">

                {message}

              </p>

            )}

          </div>

        </div>

      )}

      {/* FOOTER */}

      <footer className="footer">

        <p>
          Copyright © 2026
          BY FIDIN VENTURES.
          All Rights Reserved
        </p>

      </footer>

    </>
  );
};

export default EmployeeCorner;